import { render, staticRenderFns } from "./what_awaits_you.vue?vue&type=template&id=aab60be4&scoped=true"
import script from "./what_awaits_you.vue?vue&type=script&lang=js"
export * from "./what_awaits_you.vue?vue&type=script&lang=js"
import style0 from "./what_awaits_you.vue?vue&type=style&index=0&id=aab60be4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab60be4",
  null
  
)

export default component.exports